import Hero from '@nordinvestments/nord-storybook/dist/components/Hero'
import useBreakpointHandler from '@nordinvestments/nord-storybook/dist/hooks/useBreakpointHandler'
import React from 'react'

import BaseSection from '../../BaseSection'

const ReturnHero = () => {
  const largeAndUp = useBreakpointHandler('lg')
  const heroHeight = largeAndUp ? 'half' : 'large'

  return (
    <BaseSection.Hero
      className="text-center"
      height={heroHeight}
      backgroundImage={<Hero.Background />}
      backgroundClass="bg-nord-gradient"
      withCut
    >
      <BaseSection.Header.HeroTop className="text-white" scrollReveal>
        Afkast
      </BaseSection.Header.HeroTop>
      <BaseSection.Header.Base isHeroHeader scrollReveal>
        Et stabilt historisk afkast
      </BaseSection.Header.Base>
    </BaseSection.Hero>
  )
}

export default ReturnHero
